import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from '../utils/api';
import RSVPErrorPage from "./RSVPErrorPage";

const RSVPForm = () => {
  const [params] = useSearchParams();
  const token = params.get("token");

  const [inviteId, setInviteId] = useState(null);
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [location, setLocation] = useState("");
  const [message, setMessage] = useState("");
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [response, setResponse] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [inviter, setInviter] = useState("");
  const [flyerUrl, setFlyerUrl] = useState("");


  function formatDateRange(start, end) {
    const startDate = new Date(start);
    const endDate = new Date(end);

    const sameDay = startDate.toDateString() === endDate.toDateString();

    const dateOptions = { month: 'short', day: 'numeric', year: 'numeric' };
    const timeOptions = { hour: 'numeric', minute: '2-digit' };

    if (sameDay) {
      return `${startDate.toLocaleDateString(undefined, dateOptions)} · ${startDate.toLocaleTimeString(undefined, timeOptions)} – ${endDate.toLocaleTimeString(undefined, timeOptions)}`;
    } else {
      return `${startDate.toLocaleDateString(undefined, dateOptions)} ${startDate.toLocaleTimeString(undefined, timeOptions)} – ${endDate.toLocaleDateString(undefined, dateOptions)} ${endDate.toLocaleTimeString(undefined, timeOptions)}`;
    }
  }

  const isEventOver = (endDate) => {
    return new Date(endDate) < new Date();
  };


  // 🎯 Decode the token by calling the backend
  useEffect(() => {
    if (!token) {
      setError("Missing RSVP token");
      return;
    }

    api.get(`/rsvp/validate?token=${token}`)
      .then(res => {
        setInviteId(res.data.invite_id);
        setEmail(res.data.email);
        setName(res.data.name);
        setLocation(res.data.location);
        setMessage(res.data.message); 
        setStart(res.data.event_start); 
        setEnd(res.data.event_end); 
        setInviter(res.data.inviter);
        setFlyerUrl(res.data.flyer_url);
      })
      .catch(err => {
        console.error("❌ RSVP token validation failed:", err);

        if (err.response?.status === 410) {
          setError("This invitation is no longer available. You may have been removed from the guest list.");
        } else if (err.response?.status === 401) {
          setError("Invalid or expired RSVP link.");
        } else {
          setError("Something went wrong. Please try again later.");
        }
      });
  }, [token]);

  const handleSubmit = async () => {
    try {
      await api.post("/rsvp", {
        token: token,  // pass the RSVP token
        response: response,  // user-selected response (1 = yes, etc.)
      });
      setSubmitted(true);
    } catch (err) {
      console.error("❌ RSVP failed:", err);
      setError("Something went wrong.");
    }
  };

  if (error) {
    return <RSVPErrorPage message={error} />;
  }

  if (!inviteId || !email) {
    return <div className="container rsvp">🔄 Verifying RSVP link...</div>;
  }

  if (submitted) {
    return <div className="container rsvp"><h2>🎉 RSVP Saved!</h2></div>;
  }

  return (
    <div className="container rsvp">
      <h2>Hey {name}, You're invited!</h2>
      <div className="rsvp-invite-preview">
        {flyerUrl && (
          <div className="flyer-preview">
            <img
              src={flyerUrl}
              alt="Event Flyer"
              style={{
                width: '100%',
                maxWidth: '400px',
                height: 'auto',
                borderRadius: '6px',
                boxShadow: '0 0 6px rgba(0, 0, 0, 0.2)',
                margin: '10px 0'
              }}
            />
          </div>
        )}
        <div dangerouslySetInnerHTML={{ __html: message }} />
        <i>From: {inviter}</i>
      </div>
      <h3>
        Location: {location} 
        <span style={{ float: "right" }}>
          When: {formatDateRange(start, end)}
        </span>
      </h3>

      {isEventOver(end) ? (
        <p className="text-muted">This event has already ended. RSVPs are now closed.</p>
      ) : (
        <>
          <p>Will you attend?</p>
          <button onClick={() => setResponse(1)}>
            <i className="fa-solid fa-check text-approve" /> Yes
          </button>{" "}
          <button onClick={() => setResponse(2)}>
            <i className="fa-solid fa-xmark text-decline" /> No
          </button>
          <br /><br />
          {response && (
            <button onClick={handleSubmit}>Submit RSVP</button>
          )}
        </>
      )}
    </div>
  );
};

export default RSVPForm;
